import RestService from "./RestService";


export default class BannersService extends RestService {
    constructor() {
        super('/api/banners');
    }
}
